// fr_pms_common.ts
// Elementy wspólne dla wszystkich ekranów PMS — statusy, akcje, etykiety
// Importuj ten plik w każdym ekranowym pliku tłumaczeń zamiast powielać te same klucze.

export const frPmsCommon = {

  // ── Statusy pokoi ──────────────────────────────────────────────────────────
  roomStatus: {
    available:    "Disponible",
    occupied:     "Occupe",
    dirty:        "Sale",
    clean:        "Propre",
    cleaning:     "En nettoyage",
    inspected:    "Inspecte",
    blocked:      "Bloque",
    outOfOrder:   "Hors service",
    outOfService: "Hors service",
    unassigned:   "Non assigne",
    reserved:     "Reserve",
    maintenance:  "En maintenance",
  },

  // ── Statusy rezerwacji ─────────────────────────────────────────────────────
  reservationStatus: {
    confirmed:  "Confirmee",
    inHouse:    "En sejour",
    cancelled:  "Annulee",
    checkedOut: "Depart effectue",
    noShow:     "No-show",
    waitlist:   "Liste d'attente",
    pending:    "En attente",
    planned:    "Planifiee",
    completed:  "Terminee",
    booked:     "Reservee",
    active:     "Active",
    all:        "Toutes",
  },

  roomCalendar: {
    allTypes: "Tous les types",
    allFloors: "Tous les étages",
    floor: "Étage {{floor}}",
    filterByFloor: "Filtrer par étage",
    clearFilters: "Effacer",
    checkedOut: "Départs effectués",
    checkedIn: "Arrivées effectuées",
    cancelledNoShow: "Annulée / Non-présentation",
    showCheckedOut: "Afficher les réservations terminées",
    hideCheckedOut: "Masquer les réservations terminées",
    reservationLegend: "Légende des statuts de réservation et filtre de chambre",
    roomNumberPlaceholder: "N° de chambre",
    searchRoomNumber: "Rechercher un numéro de chambre",
  },

  // ── Ważność / Priorytet ────────────────────────────────────────────────────
  severity: {
    critical: "Critique",
    high:     "Eleve",
    medium:   "Moyen",
    low:      "Faible",
  },

  // ── Przyciski i akcje ──────────────────────────────────────────────────────
  actions: {
    save:        "Enregistrer",
    saving:      "Enregistrement...",
    cancel:      "Annuler",
    cancelling:  "Annulation...",
    close:       "Fermer",
    closing:     "Fermeture...",
    edit:        "Modifier",
    delete:      "Supprimer",
    confirm:     "Confirmer",
    approve:     "Approuver",
    create:      "Creer",
    creating:    "Creation...",
    add:         "Ajouter",
    adding:      "Ajout...",
    back:        "Retour",
    search:      "Rechercher",
    filter:      "Filtrer",
    refresh:     "Actualiser",
    download:    "Telecharger",
    preview:     "Apercu",
    print:       "Imprimer",
    send:        "Envoyer",
    modify:      "Modifier",
    viewAll:     "Tout voir",
    viewDetails: "Voir les details",
    opening:     "Ouverture...",
    set:         "Definir",
  },

  // ── Stany komunikatów ──────────────────────────────────────────────────────
  state: {
    loading:   "Chargement...",
    noData:    "Aucune donnee",
    noResults: "Aucun resultat",
    failed:    "Echec.",
  },

  // ── Wspólne etykiety pól ───────────────────────────────────────────────────
  labels: {
    guest:        "Client",
    guests:       "Clients",
    room:         "Chambre",
    rooms:        "Chambres",
    floor:        "Etage",
    night:        "Nuit",
    nights:       "Nuits",
    checkIn:      "Arrivee",
    checkOut:     "Depart",
    arrival:      "Arrivee",
    departure:    "Depart",
    arrivals:     "Arrivees",
    departures:   "Departs",
    status:       "Statut",
    operations:   "Operations",
    frontDesk:    "Reception",
    occupancy:    "Occupation",
    revenue:      "Revenu",
    billing:      "Facturation",
    housekeeping: "Housekeeping",
    department:   "Departement",
    owner:        "Responsable",
    priority:     "Priorite",
    date:         "Date",
    time:         "Heure",
    total:        "Total",
    notes:        "Notes",
    invoice:      "Facture",
    group:        "Groupe",
    type:         "Type",
    rate:         "Tarif",
    balance:      "Solde",
    amount:       "Montant",
    currency:     "Devise",
    name:         "Nom",
    email:        "Email",
    phone:        "Telephone",
    address:      "Adresse",
    country:      "Pays",
    today:        "Aujourd'hui",
    other:        "Autres",
    none:         "Aucun",
    unassigned:   "Non assigne",
    inHouse:      "En sejour",
    readyRoom:    "Chambre prete",
    noReadyRoom:  "Aucune chambre prete",
  },

} as const;

export default frPmsCommon;
